// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pWzxUhvfrsZstavp0xMq {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  align-items: center;
}

.WYjBKFJGYiL4l9LXsB0d {
  position: relative;
}

.MrB1oST46xvpBdHiBE8Q {
  font-family: Bai Jamjuree;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.WCluNI05A9yBE8Hr8lj4, .Rfga1uVqmveWGOEbDpNr, .cMZbAkGRKjgmzmdegzza {
  cursor: pointer;
  height: 48px;
  color: white;
  line-height: 28px;
  padding: 8px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: 138px;
}
.WCluNI05A9yBE8Hr8lj4::placeholder, .Rfga1uVqmveWGOEbDpNr::placeholder, .cMZbAkGRKjgmzmdegzza::placeholder {
  opacity: 0.5;
}
.WCluNI05A9yBE8Hr8lj4:focus, .Rfga1uVqmveWGOEbDpNr:focus, .cMZbAkGRKjgmzmdegzza:focus {
  outline: none;
}
.WCluNI05A9yBE8Hr8lj4:focus + .MrB1oST46xvpBdHiBE8Q, .Rfga1uVqmveWGOEbDpNr:focus + .MrB1oST46xvpBdHiBE8Q, .cMZbAkGRKjgmzmdegzza:focus + .MrB1oST46xvpBdHiBE8Q {
  color: white;
}
.WCluNI05A9yBE8Hr8lj4:disabled, .Rfga1uVqmveWGOEbDpNr:disabled, .cMZbAkGRKjgmzmdegzza:disabled {
  color: #C4C4C4;
}

.cMZbAkGRKjgmzmdegzza {
  background: rgba(69, 174, 255, 0.1) !important;
  border: 1px solid;
  border-image-source: linear-gradient(90deg, #45AEFF 0%, rgba(41, 104, 153, 0) 100%);
  border-image-slice: 1;
  border-image-width: 1;
  border-image-outset: 0;
  border-image-repeat: stretch;
}

.Rfga1uVqmveWGOEbDpNr {
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  border-radius: 2px;
}
.Rfga1uVqmveWGOEbDpNr:focus {
  background: rgba(255, 255, 255, 0.2);
}
.Rfga1uVqmveWGOEbDpNr:focus + .MrB1oST46xvpBdHiBE8Q {
  color: white;
}

.pSbtVJyTljkUGmFEtRzb {
  overflow: auto;
  margin-top: 2px;
  position: absolute;
  background: #494949;
  font-family: Figtree;
  font-weight: 400;
  font-size: 17px;
  border-radius: 8px;
  color: #FFFFFF;
  width: 100%;
  max-height: 30vh;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.2);
  z-index: 999999;
}
.pSbtVJyTljkUGmFEtRzb::-webkit-scrollbar {
  width: 4px;
}
.pSbtVJyTljkUGmFEtRzb::-webkit-scrollbar-thumb {
  width: 4px;
}
@media (max-width: 1000px) {
  .pSbtVJyTljkUGmFEtRzb {
    max-height: 50vh;
  }
}

.Hjqjc7nUeWMhHBLwy4P0 {
  bottom: 50px;
}

.o_9NrK09KIMmSuUiOvHl {
  transform: rotate(180deg);
}

.Vb82FTkWUZCRC6jITF47, .zdGcQ9Ty6NQSGMURqgEr {
  padding: 12px 16px;
}
.Vb82FTkWUZCRC6jITF47:hover, .zdGcQ9Ty6NQSGMURqgEr:hover {
  background: rgba(255, 255, 255, 0.1);
}

.zdGcQ9Ty6NQSGMURqgEr {
  background: rgba(255, 255, 255, 0.1);
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/Components/SelectInput/SelectInput.module.scss"],"names":[],"mappings":"AACA;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAAD;;AAGA;EACC,kBAAA;AAAD;;AAGA;EACC,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAAD;;AAGA;EACC,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAAD;AAGC;EACC,YAAA;AADF;AAIC;EACC,aAAA;AAFF;AAIE;EACC,YAAA;AAFH;AAMC;EACC,cAAA;AAJF;;AAQA;EAEC,8CAAA;EACA,iBAAA;EACA,mFAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,4BAAA;AAND;;AASA;EAEC,0CAAA;EACA,uBAAA;EACA,kBAAA;AAPD;AAQC;EACC,oCAAA;AANF;AAQE;EACC,YAAA;AANH;;AAWA;EACC,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,+CAAA;EACA,eAAA;AARD;AASC;EACC,UAAA;AAPF;AAUC;EACC,UAAA;AARF;AAUC;EArBD;IAsBE,gBAAA;EAPA;AACF;;AAUA;EACC,YAAA;AAPD;;AAUA;EACC,yBAAA;AAPD;;AAUA;EACC,kBAAA;AAPD;AAQC;EACC,oCAAA;AANF;;AAUA;EAEC,oCAAA;EACA,iBAAA;AARD","sourcesContent":["\r\n.selectInputContainer {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tcolumn-gap: 16px;\r\n\talign-items: center;\r\n}\r\n\r\n.inputContainer {\r\n\tposition: relative;\r\n}\r\n\r\n.label {\r\n\tfont-family: Bai Jamjuree;\r\n\tfont-weight: 400;\r\n\tfont-size: 16px;\r\n\tcolor: #FFFFFF;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.input {\r\n\tcursor: pointer;\r\n\theight: 48px;\r\n\tcolor: white;\r\n\tline-height: 28px;\r\n\tpadding: 8px 16px;\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tmin-width: 138px;\r\n\r\n\r\n\t&::placeholder {\r\n\t\topacity: 0.5;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\toutline: none;\r\n\r\n\t\t& + .label {\r\n\t\t\tcolor: white;\r\n\t\t}\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\tcolor:#C4C4C4;\r\n\t}\r\n}\r\n\r\n.inputBlue {\r\n\t@extend .input;\r\n\tbackground: rgba(69, 174, 255, 0.1) !important;\r\n\tborder: 1px solid;\r\n\tborder-image-source: linear-gradient(90deg, #45AEFF 0%, rgba(41, 104, 153, 0) 100%);\r\n\tborder-image-slice: 1;\r\n\tborder-image-width: 1;\r\n\tborder-image-outset: 0;\r\n\tborder-image-repeat: stretch;\r\n}\r\n\r\n.inputGrey {\r\n\t@extend .input;\r\n\tborder: 1px solid #FFFFFF33;\r\n\tbackground: transparent;\r\n\tborder-radius: 2px;\r\n\t&:focus {\r\n\t\tbackground: #FFFFFF33;\r\n\r\n\t\t& + .label {\r\n\t\t\tcolor: white;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.dropdownInput {\r\n\toverflow: auto;\r\n\tmargin-top: 2px;\r\n\tposition: absolute;\r\n\tbackground: #494949;\r\n\tfont-family: Figtree;\r\n\tfont-weight: 400;\r\n\tfont-size: 17px;\r\n\tborder-radius: 8px;\r\n\tcolor: #FFFFFF;\r\n\twidth: 100%;\r\n\tmax-height: 30vh;\r\n\tbox-shadow: 0px 0px 24px 0px #00000033;\r\n\tz-index: 999999;\r\n\t&::-webkit-scrollbar {\r\n\t\twidth: 4px;\r\n\t}\r\n\r\n\t&::-webkit-scrollbar-thumb {\r\n\t\twidth: 4px;\r\n\t}\r\n\t@media (max-width: 1000px) {\r\n\t\tmax-height: 50vh;\r\n\t}\r\n}\r\n\r\n.dropdownInputUp {\r\n\tbottom: 50px\r\n}\r\n\r\n.caretIconRotated {\r\n\ttransform: rotate(180deg);\r\n}\r\n\r\n.dropdownOption {\r\n\tpadding: 12px 16px;\r\n\t&:hover {\r\n\t\tbackground: rgba(255, 255, 255, 0.1);\r\n\t}\r\n}\r\n\r\n.dropdownOptionSelected {\r\n\t@extend .dropdownOption;\r\n\tbackground: rgba(255, 255, 255, 0.1);\r\n\tfont-weight: bold;\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectInputContainer": `pWzxUhvfrsZstavp0xMq`,
	"inputContainer": `WYjBKFJGYiL4l9LXsB0d`,
	"label": `MrB1oST46xvpBdHiBE8Q`,
	"input": `WCluNI05A9yBE8Hr8lj4`,
	"inputGrey": `Rfga1uVqmveWGOEbDpNr`,
	"inputBlue": `cMZbAkGRKjgmzmdegzza`,
	"dropdownInput": `pSbtVJyTljkUGmFEtRzb`,
	"dropdownInputUp": `Hjqjc7nUeWMhHBLwy4P0`,
	"caretIconRotated": `o_9NrK09KIMmSuUiOvHl`,
	"dropdownOption": `Vb82FTkWUZCRC6jITF47`,
	"dropdownOptionSelected": `zdGcQ9Ty6NQSGMURqgEr`
};
export default ___CSS_LOADER_EXPORT___;
